import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Higgins Truck Sales';
const SITE_URL = process.env.REACT_APP_BACKEND_URL || '';

export const SEO = ({ title, description, path = '', image, jsonLd }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Quality Trucks & Trailers Australia`;
  const desc =
    description ||
    'Higgins Truck Sales - quality trucks and trailers available across Australia. Browse prime movers, rigids and trailers for sale.';
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE_NAME} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
